import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-partner',
    templateUrl: './partner.component.html',
    styleUrls: ['./partner.component.css'],
    standalone: false
})
export class PartnerComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

}
